import { Components } from '@mui/material/styles'

export const MuiCardOverrides: Components['MuiCard'] = {
  styleOverrides: {
    root: {
      borderRadius: 1.5, // 12px (1.5 * 8px)
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      transition: 'box-shadow 0.2s ease-in-out',
      '&:hover': {
        boxShadow: '0 4px 16px rgba(0,0,0,0.15)',
      },
    },
  },
}

export const MuiCardContentOverrides: Components['MuiCardContent'] = {
  styleOverrides: {
    root: {
      padding: 3, // 24px (3 * 8px)
      '&:last-child': {
        paddingBottom: 3, // 24px (3 * 8px)
      },
    },
  },
}

export const MuiCardActionsOverrides: Components['MuiCardActions'] = {
  styleOverrides: {
    root: {
      padding: '8px 16px 16px 16px', // Mixed values for specific layout
      gap: 1, // 8px (1 * 8px)
    },
  },
}
